export default "__VITE_ASSET__9b801165__"